<template>
  <b-card class="rounded-xl">
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          Integrations
        </h2>
      </div>
    </div>
    <!-- <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class=" cursor-pointer  mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group> -->

    <div class="lg:grid md:grid md:grid-cols-2 lg:grid-cols-3  gap-8 mt-12">
      <b-card
        class=" rounded-2xl  cust-shadow"
        v-for="(item, index) in steps"
        :key="'item -' + index"
      >
        <div>
          <div class="mb-4 flex justify-center">
            <div class="w-24 h-24">
              <img :src="item.img" alt="..." />
            </div>
          </div>
          <div class=" pt-2 text-center">
            <p
              class="md:mb-3 lg:mb-3 mb-1 font-bold theme-color-tx md:text-lg lg:text-lg text-lg"
            >
              {{ item.title }}
            </p>
          </div>
        </div>
      </b-card>
    </div>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      steps: [
        {
          title: "Google Analytics",
          img: require("../img/try.png")
        },
        {
          title: "Razorpay",
          img: require("../img/rozar.png")
        }
      ]
    };
  }
};
</script>
